import React from "react";

function normalizeRenderError(error) {
  if (error instanceof Error) {
    const m = (error.message || "").trim();
    if (m) return m;
    return `${error.name || "Error"} en la interfaz (sin mensaje). Abra la consola (F12) para más detalle.`;
  }
  return reasonToTextStatic(error);
}

function reasonToTextStatic(reason) {
  if (reason == null) return "Error desconocido.";
  if (typeof reason === "string") return reason.trim() || "Error desconocido.";
  try {
    const s = JSON.stringify(reason);
    return s && s !== "{}" ? s : "Error desconocido.";
  } catch {
    return String(reason);
  }
}

/**
 * Captura errores de renderizado en el árbol de React (no captura errores async en manejadores de eventos).
 */
export class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error: normalizeRenderError(error) };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error("[ICJEME] ErrorBoundary (render):", error, errorInfo);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            padding: 24,
            fontFamily: "system-ui, sans-serif",
            maxWidth: 560,
            margin: "48px auto",
          }}
        >
          <h1 style={{ color: "#b91c1c", fontSize: "1.25rem" }}>Algo salió mal en la aplicación</h1>
          <p style={{ color: "#334155", whiteSpace: "pre-wrap" }}>{this.state.error}</p>
          <button
            type="button"
            style={{
              marginTop: 16,
              padding: "10px 16px",
              background: "#1d4ed8",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
            }}
            onClick={() => window.location.reload()}
          >
            Recargar página
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
